import React from 'react';
import {SolutionsData} from 'models/app';

export default React.createContext<SolutionsData>({dataByCategory: {}, categories: []});
